
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands, getDateRange } from "@common/src/utils/common";
import dayjs from "dayjs";
import echarts from "echarts";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const common_statement = namespace("common_statement");
const statement = namespace("statement");
const base = namespace("base");
const management = namespace("management");
const serviceItem = namespace("service-item");
const parts = namespace("parts");
@Component({
  components: { TextTips }
})
export default class Statement extends Vue {
  @statement.Action getTurnOverAnalysisModel;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @serviceItem.Action getServiceItemList;
  @common_statement.Action queryReceiptReportDetail;
  @parts.Action getPartsList;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    reportType: "1", // 时间范围类型, date-按日,month-按月
    receiptTimeFrom: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    receiptTimeTo: "", // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    timeType: "1"
  };
  get breadData() {
    return [
      { name: t("v213.collection-doc-report"), path: "/statement/receipt-report-list" },
      { name: t("v213.collection-doc-analysis") }
    ];
  }
  contentList: any = [];
  created() {
    this.init();
  }
  mounted() {
    this.myChart = echarts.init(document.querySelector(".charts-el"));
  }
  get searchList() {
    return [
      {
        label: t("v3_2_0.date-type"),
        type: "select",
        selectList: [
          {
            label: t("v3_2_0.payment-and-receipt-time"),
            value: "1"
          },
          {
            label: t("v213.Created-time"),
            value: "2"
          }
        ],
        prop: "timeType",
        clearable: false,
        required: true,
        value: this.searchForm.timeType
      },
      {
        label: t("v216_6.statistical-dimension"),
        type: "btn-radio",
        prop: "reportType",
        options: this.dateTypeOptions,
        value: this.searchForm.reportType,
        typeChangeMethod: this.handleDateTypeChange,
        required: true
      },
      ...(this.searchForm.reportType === "1"
        ? [
            {
              label: t("v210831.time-frame"),
              value: [this.searchForm.receiptTimeFrom, this.searchForm.receiptTimeTo],
              resetValue: this.getDefaultDate("1"),
              type: "daterange",
              prop: "date",
              required: true,
              disabledFuture: true,
              maxDay: 90
            }
          ]
        : [
            {
              label: t("v210831.time-frame"),
              value: [this.searchForm.receiptTimeFrom, this.searchForm.receiptTimeTo],
              resetValue: this.getDefaultDate("2"),
              type: "monthrange",
              prop: "month",
              required: true,
              disabledFuture: true,
              maxMonth: 12
            }
          ])
    ];
  }
  myChart: any = undefined;
  routeParams: any = {};
  init() {
    this.routeParams = this.queryBody;
    if (this.routeParams) {
      this.searchForm = this.routeParams;
    } else {
      this.handleDateTypeChange(this.searchForm.statisticMethod);
    }
    delete this.searchForm.fromList;
    this.queryReportDetail();
  }

  reportData: any = {};
  queryReportDetail() {
    this.queryReceiptReportDetail(this.searchForm).then(data => {
      const series = [];
      const valueArr = [];
      const xAxisData = [];
      data.data?.list.forEach((item, index) => {
        item.receiptDetials.forEach((itemDetail, detailIndex) => {
          if (index === 0) {
            series.push({
              name: itemDetail.receiptTypeDesc,
              type: "bar",
              stack: "Ad",
              barWidth: 36,
              emphasis: {
                focus: "series"
              },
              data: []
            });
            valueArr[detailIndex] = [];
          }
          valueArr[detailIndex][index] = Number(itemDetail.receiptAmount);
        });
        if (this.searchForm.reportType === "1") {
          xAxisData.push(item.receiptTime.slice(-5));
        } else {
          xAxisData.push(item.receiptTime);
        }
      });
      series.forEach((seriesItem, index) => {
        seriesItem.data = valueArr[index];
      });
      console.log(series, valueArr);
      this.draw(series, xAxisData);
    });
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "date" || item.prop === "month") {
          this.searchForm.receiptTimeFrom = item.value?.[0];
          this.searchForm.receiptTimeTo = item.value?.[1];
        } else {
          this.searchForm[item.valueAlias || item.prop] = item.value;
        }
      }
    });
    this.queryReportDetail();
  }
  draw(series, xAxisData) {
    let options = {
      color: ["#2278F5", "#599AFA", "#00B478", "#5FC71A", "#FEBC00", "#FF9900", "#FE7000"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        formatter: params => {
          let str = `${params[0].name}<br>`;
          let totalAmount = 0;
          str += params
            .map(item => {
              totalAmount += item.value;
              return `<div style="display:flex;justify-content:space-between"><span style="margin-right:5px">${item.marker} ${item.seriesName}:</span><span>${this.$localMark.currencySymbol} ${item.value}</span></div>`;
            })
            .join("");
          str += `<span style="display:flex;border-bottom: #BFBFBF 1px solid;margin:5px 0px"></span>`;
          str += `<div style="display:flex;justify-content:space-between"><span style="padding-left:18px">${t(
            "v213.receipt-all"
          )}:</span> <span>${this.$localMark.currencySymbol} ${totalAmount.toFixed(2)}</span></div>`;
          return str;
        }
      },
      legend: {
        show: true,
        bottom: 20
      },
      grid: {
        top: "50px",
        left: "3%",
        right: "4%",
        bottom: "80px",
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisLabel: {
            textStyle: {
              //文字样式
              color: "#8C8C8C",
              fontSize: "12"
            },
            rotate: series?.[0]?.data.length > 20 ? 40 : 0 //倾斜度可以根据需求设置
          }
        }
      ],
      yAxis: [
        {
          name: t("base.unit") + ":" + this.$localMark.currency,
          axisTick: { show: false },
          type: "value"
        }
      ],
      series: series
    };
    this.myChart.setOption(options, true);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  }

  get queryBody() {
    if (this.$route.query.searchForm) {
      return JSON.parse(this.$route.query.searchForm as string);
    } else {
      return null;
    }
  }
  dateTypeOptions = [
    { label: t("sb_copy.query-by-day"), value: "1" },
    { label: t("sb_copy.query-by-month"), value: "2" }
  ];
  handleDateTypeChange(val) {
    [this.searchForm.receiptTimeFrom, this.searchForm.receiptTimeTo] = this.getDefaultDate(val);
    this.searchForm.reportType = val;
  }

  getDefaultDate(type: "1" | "2"): Array<string> {
    if (type === "1") {
      return getDateRange("first_day_to_today_of_current_month", "YYYYMMDD");
    } else if (type === "2") {
      return getDateRange("first_month_to_current_month_of_current_year", "YYYYMM");
    } else {
      return [];
    }
  }
}
